// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './utils/flexible'
import './assets/styles/index.css'
import '@/permission' // permission control
import vueTap from 'v-tap'

import { TabItem, Loadmore, TabContainer, TabContainerItem, InfiniteScroll, Spinner, Switch, Picker } from 'mint-ui'
import VueClipboard from 'vue-clipboard2'

import Header from '@/components/Header'

import '@/utils/check-net.js'
// import '@/utils/check-wx.js'

Vue.use(VueClipboard)

Vue.use(vueTap)

Vue.component(TabItem.name, TabItem)
Vue.component(Loadmore.name, Loadmore)
Vue.component(TabContainer.name, TabContainer)
Vue.component(TabContainerItem.name, TabContainerItem)
Vue.component(Spinner.name, Spinner)
Vue.component(Switch.name, Switch)
Vue.component(Picker.name, Picker);
Vue.use(InfiniteScroll)

Vue.component(Header.name, Header)

Vue.config.productionTip = false

// Vue.mixin({
// beforeRouteLeave (to, from, next) {
// console.log(to, from, next)
// this.$destroy()
// next()
// } // ,
// created () {
//   let ua = navigator.userAgent.toLowerCase()
//   if (ua.match(/MicroMessenger/i) === 'micromessenger') {
//     console.log(history.state)
//     history.replaceState(history.state, null, window.location.href)
//     let url = window.location.href
//     console.log(url)
//   }
// }
// })


// 解决 ios 微信 里键盘收起后页面无法回退的问题
Vue.mixin({
  mounted() {
    this.$nextTick(() => {
      this.iosInputBack()
    })
  },
  methods: {
    iosInputBack() {
      let ua = navigator.userAgent;
      if (/MicroMessenger/i.test(ua) && /(iPhone|iPad|iPod|iOS)/i.test(ua)) {
          let inputArr = document.querySelectorAll('input');
          let inputTimer = null;
          inputArr.forEach(item => {
              item.addEventListener('blur', () => {
                  inputTimer = setTimeout(() => {
                      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                      document.documentElement.scrollTop = document.body.scrollTop = scrollTop;
                      // window.scrollTo(scrollTop, 0)
                      clearTimeout(inputTimer)
                  }, 200)
              })
              item.addEventListener('focus', () => {
                  clearTimeout(inputTimer);
              })
          })
      }
    }
  }
})

Vue.filter('imgUrlTransform', function (value) {
  if (typeof value === 'string' && value !== '' ) {
    if (value === 'xxx.jpg') {
      return value
    } else {
      return process.env.IMG_PREFIX + value
    }
  } else {
    return value
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js